/**
 * Created by jv on 2019-09-09 (15:49).
 */
import utils from "Sources/utils/utils";
const log = require("Sources/utils/logger")();
const SOCKET_STATES = {
  CONNECTING: WebSocket ? WebSocket.CONNECTING : 0,
  OPEN: WebSocket ? WebSocket.OPEN : 1,
  CLOSING: WebSocket ? WebSocket.CLOSING : 2,
  CLOSED: WebSocket ? WebSocket.CLOSED : 3
};
class WebSocketClient
{
  constructor(options)
  {
    this.url = options.url;
    this.onOpen = options.onOpen;
    this.onClose = options.onClose;
    this.onError = options.onError;
    this.onMessage = options.onMessage;
  }

  open()
  {
    this.socket = new WebSocket(this.url);

    this.socket.onopen = (event) => this._onOpen(event);
    this.socket.onmessage = (event) => this._onMessage(event);
    this.socket.onclose = (event) => this._onClose(event);
    this.socket.onerror = (event) => this._onError(event);
  }

  close(code, reason)
  {
    if(utils.isNotNull(this.socket) && this.socket.readyState === SOCKET_STATES.OPEN)
    {
      this.socket.close(code, reason);
    }
  }

  isConnected()
  {
    if(utils.isNotNull(this.socket))
    {
      return this.socket.readyState === SOCKET_STATES.OPEN;
    }
    return false;
  }

  isClosed()
  {
    if(utils.isNotNull(this.socket))
    {
      return this.socket.readyState === SOCKET_STATES.CLOSED;
    }
    return false;
  }

  sendData(data)
  {
    if(utils.isNotNull(this.socket) && this.isConnected())
    {
      this.socket.send(data);
    }
  }

  _onOpen(event)
  {
    log.debug("websocket connection established - %o", event);
    if(utils.isFunction(this.onOpen))
    {
      this.onOpen.call(this, event);
    }
  }

  _onMessage(event)
  {
    //log.debug("websocket messaged received - %o", event);
    if(utils.isFunction(this.onMessage))
    {
      this.onMessage.call(this, event);
    }
  }

  _onClose(event)
  {
    log.debug("websocket connection closed - %o", event);
    if(utils.isFunction(this.onClose))
    {
      this.onClose.call(this, event);
    }
  }

  _onError(event)
  {
    log.error("websocket error occurred - %o", event);
    if(utils.isFunction(this.onError))
    {
      this.onError.call(this, event);
    }
  }
}
export default WebSocketClient;



// WEBPACK FOOTER //
// ./app/js/realtime/client.js